export default __webpack_public_path__ + "static/media/Amper_photo_05.4b5cd8d1.jpg";